import React, { useContext, useEffect } from "react";
import classes from "./ProfileComponents.module.scss";
// import { useForm } from "react-hook-form";
// import { yupResolver } from "@hookform/resolvers/yup";
// import * as yup from "yup";
import { useFormContext } from "react-hook-form";
import WarningTooltip from "./WarningTooltip";
import { useTranslation } from 'react-i18next';
import { OrgIdContext } from "../../store/orgId_context";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';


const Details = ({
  // onInputChangeHandler,
  // taxNum,
  // vatNum,
  // regNum,
  // budgetNum,
  isEditMode,
  onFormReset,
  shouldReset,
}) => {
  const { t } = useTranslation();
  const {sessionInfo} = useContext(OrgIdContext)
  // const schema = yup.object().shape({
  //   taxNum: yup.number().default(taxNum),
  //   vatNum: yup.number().default(vatNum),
  //   regNum: yup.number().default(regNum),
  //   budgetNum: yup.number().default(budgetNum),
  // });

  const { register, reset, formState: { errors }, } = useFormContext();
  
  // const { register, reset } = useForm({
  //   resolver: yupResolver(schema),
  //   mode: "onChange",
  //   reValidateMode: "onSubmit",
  //   values: {
  //     taxNum: taxNum,
  //     vatNum: vatNum,
  //     regNum: regNum,
  //     budgetNum: budgetNum,
  //   },
  // });

  useEffect(() => {
    if (shouldReset) {
      reset();
      onFormReset();
    }
  }, [shouldReset, reset, onFormReset]);

  return (
    <>
      <h3 className={classes.subtitle}>{t("Details")}</h3>
      <div className={classes.container}>
        <fieldset className={classes["input-container"]} disabled={!isEditMode}>
          <label htmlFor="taxNum">{t("Tax Number*")} (EU: w/o country prefix!)
            <OverlayTrigger placement="top" overlay={<Tooltip>{t("A number for tax. In EU is without country prefix.")}</Tooltip>}>
              <HelpOutlineIcon style={{marginLeft:"0.3rem", fontSize:"1rem"}}/>
            </OverlayTrigger>
          {errors.taxNum && <>
              <WarningTooltip text={errors.taxNum?.message}/>
              
            </>}</label>
          <input
            type="text"
            name="taxNum"
            id="taxNum"
            style={errors.taxNum ? {outlineColor:"red"}: {}}
            {...register("taxNum")}
          />
        </fieldset>

        <fieldset className={classes["input-container"]} disabled={!isEditMode}>
          <label htmlFor="vatNum">{t("VAT Number")} (EU: with country prefix!)
            <OverlayTrigger placement="top" overlay={<Tooltip>{t("A number of VAT. In EU with country prefix.")}</Tooltip>}>
              <HelpOutlineIcon style={{marginLeft:"0.3rem", fontSize:"1rem"}}/>
            </OverlayTrigger>
            {errors.vatNum && <>
              <WarningTooltip text={errors.vatNum?.message}/>
              
            </>}</label>
          <input
            type="text"
            name="vatNum"
            id="vatNum"
            style={errors.vatNum ? {outlineColor:"red"}: {}}
            {...register("vatNum")}
          />
        </fieldset>

        <fieldset className={classes["input-container"]} disabled={!isEditMode}>
          <label htmlFor="regNum">
          {t("Registration / Company Number")}
            <OverlayTrigger placement="top" overlay={<Tooltip>{t("A number of your company from the business registry, also called company/registration/corporate identification number. This number is sometimes required for e-invoicing. Note: in some countries this number can be same as tax number.")}</Tooltip>}>
              <HelpOutlineIcon style={{marginLeft:"0.3rem", fontSize:"1rem"}}/>
            </OverlayTrigger>
            {errors.regNum && <>
              <WarningTooltip text={errors.regNum?.message}/>
              
            </>}
          </label>
          <input
            type="text"
            name="regNum"
            id="regNum"
            style={errors.regNum ? {outlineColor:"red"}: {}}
            {...register("regNum")}
          />
        </fieldset>

        <fieldset className={classes["input-container"]} disabled={!isEditMode}>
          <label htmlFor="budgetNum">
          {t("Budget Number")}
          <OverlayTrigger placement="top" overlay={<Tooltip>{t("This number is used only if you are a public entity.")}</Tooltip>}>
              <HelpOutlineIcon style={{marginLeft:"0.3rem", fontSize:"1rem"}}/>
            </OverlayTrigger>
            {errors.budgetNum && <>
              <WarningTooltip text={errors.budgetNum?.message}/>
              
            </>}
          </label>
          <input
            type="text"
            name="budgetNum"
            id="budgetNum"
            style={errors.budgetNum ? {outlineColor:"red"}: {}}
            {...register("budgetNum")}
          />
        </fieldset>
        
      </div>
    </>
  );
};

export default Details;
